import React from "react";
import { Link } from "react-router-dom";

const TextLink = ({ text, href }) => {
  return (
    <Link
      to={href}
      className="text-link"
    >
      {text}
    </Link>
  );
};

export default TextLink;
